import { render, staticRenderFns } from "./TodoDetailModal.vue?vue&type=template&id=6fed2642&scoped=true&"
import script from "./TodoDetailModal.vue?vue&type=script&lang=js&"
export * from "./TodoDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./TodoDetailModal.vue?vue&type=style&index=0&id=6fed2642&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fed2642",
  null
  
)

export default component.exports